import SuccessGreenAnimationJson from 'assets/ver2/lotties/success-green-animation.json';
import ButtonCommon from 'components/common/ButtonCommon';
import SizeBox from 'components/common/SizeBox';
import {
  DESKTOP_MIN_WIDTH,
  FUNC_DEFAULT,
  MOBILE_MIN_WIDTH,
  SCREEN_ID_REMITTANCE_HOME,
  TABLET_MAX_WIDTH,
} from 'constants';
import useReferral from 'features/referral/hooks/useReferral';
import useAutoShowEventModal from 'hooks/useAutoShowEventModal';
import useLang from 'hooks/useLang';
import Lottie from 'lottie-react';
import Modal from 'react-bootstrap/Modal';
import styled from 'styled-components';
import {
  displayFlexRowCenterCenterMixin,
  displayGridCenterCenterMixin,
  fontSize24Mixin,
  paragraph500Mixin,
  textBreakLineWordMixin,
} from 'styles';

const FormProfileKYCSuccessPopup = ({
  isOpen,
  onClose,
  isBackdropOverlap,
  zIndexBackdropOverlap,
  zIndexModal = 0,
}) => {
  const { t } = useLang();
  const { isReferee1st } = useReferral();

  const { showEventModal } = useAutoShowEventModal({
    screenId: SCREEN_ID_REMITTANCE_HOME,
    params: [],
    modalStyles: {
      width: 436,
      borderRadius: 20,
    },
    modalOptions: {
      action1Name: 'close',
      action2Name: isReferee1st ? 'send-now' : 'refer-now',
    },
    isForceToCheckEventEligible: true,
    isPreventAutoShowEventModal: true,
  });

  const handleOnClose = () => {
    onClose();
    showEventModal();
  };

  const renderBodyContent = () => {
    return (
      <BodyContent>
        <FormImage>
          <Lottie
            animationData={SuccessGreenAnimationJson}
            loop={false}
            style={{
              width: '300px',
              height: '300px',
            }}
          />
        </FormImage>
        <FormTitle>{t('form_profile_kyc_success_modal_title')}</FormTitle>
        <SizeBox height={10} />
        <FormDesc
          dangerouslySetInnerHTML={{
            __html: t('form_profile_kyc_success_modal_desc'),
          }}
        />
        <SizeBox height={10} />
      </BodyContent>
    );
  };

  const renderActionButton1 = (width) => (
    <ButtonCommon
      value={t('button_close')}
      onClick={handleOnClose}
      styles={{
        margin: '0px',
        height: '50px',
        width,
      }}
      color="#002FF1"
      background="var(--ds-c-white)"
    />
  );
  const renderActionButtons = () => {
    return <>{renderActionButton1('100%')}</>;
  };

  return (
    <>
      <style>
        {zIndexModal &&
          `
          .form-profile-kyc-success-modal {
            z-index: ${zIndexModal || '1101'};
          }
        `}
        {isBackdropOverlap
          ? `
          .form-profile-kyc-success-modal-backdrop {
            z-index: ${zIndexBackdropOverlap || '1100'}!important;
            background: #212121;
            opacity: 0.7!important;
            display: initial!important;
          }
        `
          : `
        .form-profile-kyc-success-modal-backdrop {
          background: #212121;
          opacity: 0.7!important;
          display: initial!important;
        }
      `}
      </style>
      <ModalStyled
        show={isOpen}
        onHide={FUNC_DEFAULT}
        aria-labelledby="contained-modal-title-vcenter"
        className="form-profile-kyc-success-modal"
        backdropClassName="form-profile-kyc-success-modal-backdrop"
        centered
      >
        <ModalBody>{renderBodyContent()}</ModalBody>
        <ModalFooter>{renderActionButtons()}</ModalFooter>
      </ModalStyled>
    </>
  );
};

const ModalStyled = styled(Modal)`
  & .modal-dialog {
    transform: none;
    & .modal-content {
      padding: 16px;
      border-radius: 8px;
      box-shadow: var(--ds-bs-4);
      background: var(--ds-c-white);
      width: 100%;
      height: fit-content;
      margin-inline: auto;
      border: none;
    }
  }

  @media screen and (min-width: ${MOBILE_MIN_WIDTH}px) and (max-width: ${TABLET_MAX_WIDTH -
    1}px) {
    padding: 16px !important;
    & .modal-dialog {
      margin: 0;
      margin-inline: auto;
    }
  }

  @media screen and (min-width: ${DESKTOP_MIN_WIDTH}px) {
    padding-right: 0px !important;
    & .modal-dialog {
      & .modal-content {
        width: 436px;
      }
    }
  }
`;

const ModalBody = styled(Modal.Body)`
  padding: 0;
  text-align: center;
`;
const BodyContent = styled.div`
  ${displayGridCenterCenterMixin};
`;

const ModalFooter = styled(Modal.Footer)`
  border: none;
  padding: 0;
  display: flex;
`;

const FormTitle = styled.h1`
  ${paragraph500Mixin};
  ${fontSize24Mixin};
  font-family: var(--ff-quaternary);
  text-align: center;
`;
const FormDesc = styled.p`
  ${paragraph500Mixin};
  text-align: center;
  ${textBreakLineWordMixin};
`;

const FormImage = styled.div`
  ${displayFlexRowCenterCenterMixin};
  width: 100%;
  margin-bottom: -60px;
`;

export default FormProfileKYCSuccessPopup;
